import { SINATRA_LOGOUT } from '@rsos/sinatra';
// backend now calls geofences `jurisdictions`. see #2 in description of https://rapidsos.atlassian.net/browse/MC-5807
// TODO? rename geofences to `jurisdictions` to match backend
import {
  FORCED_LOGOUT_SUCCESS,
  SET_CURRENT_GEOFENCE,
  SET_GEOFENCES,
  LOGOUT_SUCCESS,
} from '../actions/actionTypes';

// TODO: deprecate this and move towards RTK

const pickJurisdiction = jurisdictions => {
  let pickedJurisdiction;
  if (jurisdictions.length === 0) {
    pickedJurisdiction = null;
  } else if (jurisdictions.length > 1) {
    pickedJurisdiction = jurisdictions.find(
      jurisdiction =>
        jurisdiction.egress_status === 3 && jurisdiction.ingress_status !== 3,
    );
    if (!pickedJurisdiction) {
      pickedJurisdiction = jurisdictions.find(
        jurisdiction => jurisdiction.egress_status === 3,
      );
    }
  } else {
    pickedJurisdiction = jurisdictions[0];
  }
  return pickedJurisdiction;
};

const FETCH_PSAP_INFO_FULFILLED = 'psap/fetchPsapInfo/fulfilled';

const initialState = {
  currentGeofence: {
    authority_id: '',
    egress_status: null,
    ingress_status: null,
    id: '',
    shapes: [],
  }, // TODO: whitelist in redux-persist
  geofences: [],
  error: null,
};

const geofences = (state = initialState, action) => {
  switch (action.type) {
    case FORCED_LOGOUT_SUCCESS:
    case LOGOUT_SUCCESS:
    case SINATRA_LOGOUT:
      return initialState;
    case SET_CURRENT_GEOFENCE:
      return {
        ...state,
        currentGeofence: action.geofence,
      };
    case SET_GEOFENCES:
      return {
        ...state,
        geofences: action.geofences,
      };
    case FETCH_PSAP_INFO_FULFILLED: {
      const jurisdictions = action.payload.jurisdictions;
      return {
        ...state,
        geofences: jurisdictions,
        currentGeofence: pickJurisdiction(jurisdictions),
      };
    }
    default:
      return state;
  }
};

export default geofences;
